import { useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import routes from "../../api/routes";
import useApiRequest from "../../api/api";
import { useUser } from "../../context/user-context";
import { useSnackbar } from "./SnackbarProvider";

export const useGoogleAuth = ({ isLoading = () => {} } = {}) => {
  const navigate = useNavigate();
  const { makeApiCall } = useApiRequest();
  const { user, updateUser } = useUser();
  const showSnackbar = useSnackbar(); // Use the global Snackbar

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        isLoading(true);

        const accessToken = response.access_token;

        // Fetch user info from Google API using fetch
        const userInfoResponse = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!userInfoResponse.ok) {
          throw new Error("Failed to fetch user info");
        }

        const userInfo = await userInfoResponse.json();
        const payload = {
          googleUserId: userInfo.sub,
          username: userInfo.name,
          email: userInfo.email,
          image: userInfo.picture,
          userTypeId: 2,
        };
        const responseApi = await makeApiCall(routes.auth.sso, "POST", payload);
        if (responseApi.success) {
          localStorage.setItem("user", JSON.stringify(responseApi.data));
          updateUser(responseApi.data);
          navigate("/home");
        } else {
          showSnackbar(responseApi.message, "error");
        }
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      } finally {
        // Stop the loading state
        isLoading(false);
      }
    },
    onError: (error) => {
      console.error("Login Failed:", error);

      isLoading(false);
    },
  });
  const storedUser = JSON.parse(localStorage.getItem("user"));

  const handleGoogleConnect = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        const accessToken = response.access_token;

        // Fetch user info from Google API using fetch
        const userInfoResponse = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        if (!userInfoResponse.ok) {
          throw new Error("Failed to fetch user info");
        }

        const userInfo = await userInfoResponse.json();
        const payload = {
          username: storedUser.username,
          image: storedUser.image, // Include image if selected
          subscribeToNewsletter: storedUser.subscribeToNewsletter,
          facebookUserId: storedUser.facebookUserId,
          appleUserId: storedUser.appleUserId,
          googleUserId: userInfo.sub,
        };
        const responseApi = await makeApiCall(
          routes.profile.account,
          "PUT",
          payload
        );
        if (responseApi.success) {
          const storedUser = JSON.parse(localStorage.getItem("user")) || {};
          storedUser.googleUserId = userInfo.sub; // Update googleUserId
          localStorage.setItem("user", JSON.stringify(storedUser));
        }
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      }
    },
    onError: (error) => {
      console.error("Login Failed:", error);
    },
  });

  return { handleGoogleLogin, handleGoogleConnect };
};
